/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Ex_NoteInputs */

const en_diff_ex_note = /** @type {(inputs: Diff_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The paths are complete, so name and meta.city can be read directly as accessors. Note that no output is produced for keys that are identical on both sides.`)
};

const ko_diff_ex_note = /** @type {(inputs: Diff_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경로가 완전하므로 name과 meta.city는 그대로 접근자로 읽을 수 있습니다. 양쪽이 동일한 키에 대해서는 아무 출력도 나오지 않는다는 점에 주의하세요.`)
};

const ja_diff_ex_note = /** @type {(inputs: Diff_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスは完全なので、name と meta.city はそのままアクセサとして読めます。両側で同一のキーについては何も出力されない点に注意してください。`)
};

/**
* | output |
* | --- |
* | "The paths are complete, so name and meta.city can be read directly as accessors. Note that no output is produced for keys that are identical on both sides." |
*
* @param {Diff_Ex_NoteInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_ex_note = /** @type {((inputs?: Diff_Ex_NoteInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Ex_NoteInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_ex_note(inputs)
	if (locale === "ko") return ko_diff_ex_note(inputs)
	return ja_diff_ex_note(inputs)
});